import { type FC } from 'react';
import { Fieldset, type MantineSize, Text } from '@mantine/core';
import { BankIdentity } from '~/entities/bank';
import { type PayoutRequisiteV2 } from '~/entities/payout';
import { KeyValuePair } from '~/shared/ui/KeyValuePair';
import { CopyInput } from '~/shared/ui/CopyInput';

interface RequisitesProps {
    requisiteV2: PayoutRequisiteV2 | undefined;
    size?: MantineSize;
}

export const Requisites: FC<RequisitesProps> = ({ requisiteV2, size = 'sm' }) => {
    const { card, sbp } = requisiteV2 ?? {};
    const hasContent = Boolean(card?.bankCode || card?.holder || card?.number || sbp?.bankCode || sbp?.phoneNumber);

    if (!hasContent) {
        return null;
    }

    return (
        <Fieldset
            w='100%'
            radius='lg'
            legend={
                <Text
                    size={size}
                    fw={700}
                >
                    Реквизиты
                </Text>
            }
        >
            {card?.bankCode && (
                <KeyValuePair
                    size={size}
                    label='Банк'
                    value={
                        <BankIdentity
                            bankCode={card.bankCode}
                            size={size}
                        />
                    }
                />
            )}

            {card?.holder && (
                <KeyValuePair
                    size={size}
                    label='Владелец карты'
                    value={
                        <CopyInput
                            size={size}
                            value={card.holder}
                        />
                    }
                />
            )}

            {card?.number && (
                <KeyValuePair
                    size={size}
                    label='Номер карты'
                    value={
                        <CopyInput
                            size={size}
                            value={card.number}
                        />
                    }
                />
            )}

            {sbp?.bankCode && (
                <KeyValuePair
                    size={size}
                    label='Банк'
                    value={
                        <BankIdentity
                            bankCode={sbp.bankCode}
                            size={size}
                        />
                    }
                />
            )}

            {sbp?.phoneNumber && (
                <KeyValuePair
                    size={size}
                    label='Номер телефона'
                    value={
                        <CopyInput
                            size={size}
                            value={sbp.phoneNumber}
                        />
                    }
                />
            )}
        </Fieldset>
    );
};
